import { createApp } from 'vue';
import { SmartidLogin, MobileidLogin } from './estonianIdAuth';

window.addEventListener('DOMContentLoaded', function () {
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        $('.message-error').remove();
    })
});

const app = createApp({
    data() {
        return {
            verificationCode: '',
            errorMessages: '',
            error: ''
        };
    }
});

app.component('smartid-login', SmartidLogin);
app.component('mobileid-login', MobileidLogin);
app.mount('#login-page');